// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultDescription__text-e3b9e1 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
  color: var(--color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupDescription/DefaultDescription/DefaultDescription.style.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,4CAAA;EACA,kCAAA;AACF","sourcesContent":[".text {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle);\n  color: var(--color-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `DefaultDescription__text-e3b9e1`
};
module.exports = ___CSS_LOADER_EXPORT___;
